import { Directive, Input, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { Subscription } from 'rxjs';
import { Dialog } from 'primeng/dialog';
import { TabTitleService } from 'src/app/services/tab-title.service';

/**
 * Syncs the browser tab title to a host `p-dialog`'s open/close state.
 *
 * Usage: `<p-dialog [appTabTitle]="header" ...>`. Listens to the host
 * `Dialog`'s own `onShow`/`onHide` outputs (no template wiring needed beyond
 * the attribute) and pushes/pops through `TabTitleService`, which restores
 * whatever title was active before the dialog opened — including another
 * dialog's title, for dialogs nested inside `create-new-document`.
 */
@Directive({
  selector: '[appTabTitle]'
})
export class TabTitleDirective implements OnInit, OnDestroy {

  @Input() appTabTitle: string;

  private pushed = false;
  private showSub: Subscription;
  private hideSub: Subscription;

  constructor(@Self() @Optional() private dialog: Dialog, private tabTitleService: TabTitleService) { }

  ngOnInit(): void {
    if (!this.dialog) return;

    this.showSub = this.dialog.onShow.subscribe(() => {
      this.tabTitleService.pushTitle(this.appTabTitle);
      this.pushed = true;
    });

    this.hideSub = this.dialog.onHide.subscribe(() => {
      if (this.pushed) {
        this.tabTitleService.popTitle();
        this.pushed = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.showSub?.unsubscribe();
    this.hideSub?.unsubscribe();
    if (this.pushed) {
      this.tabTitleService.popTitle();
      this.pushed = false;
    }
  }
}
